import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';
import autobind from 'autobind-decorator';
import { Input } from 'reactstrap';
import { ListGroupItem, Button } from 'reactstrap';
import { Label, Col, FormGroup } from 'reactstrap';
import { picOrNot } from 'customers/reports/ReportMeasure';

@connect(state => ({
	auth: state.apa
}))
export class RiskMeasure extends Component {
	constructor(props) {
		super(props);
		const report = this.props.report;
		const measure = this.props.measure;
		const riskMeasure = report.catalog_measures.find(x => x.measure == measure.id) || {
			catalog: props.report.id,
			measure: props.measure.id,
			id: '',
			contact: '',
			control: '',
			till: '',
			importance: 0,
			free_text: ''
		};
		this.state = { ...riskMeasure };
	}
	@autobind
	submit() {
		const relevance = this.state.relevance;
		const id = this.state.id;
		if (relevance === 0) {
			this.delete();
		}
		else {
			if (id === '') {
				this.create();
			}
			else {
				this.update();
			}
		}
	}
	@autobind
	create() {
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const body = JSON.stringify(this.state);
		fetch('/api/risk_measures/', { headers, method: 'POST', body }).then(res => res.json()).then(cc => this.setState(cc));
	}
	@autobind
	update() {
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const state = this.state
		delete state.picture;
		const body = JSON.stringify(state);
		fetch(`/api/risk_measures/${this.state.id}/`, { headers, method: 'PATCH', body }).then(res => res.json()).then(cc => this.setState(cc));
	}
	@autobind
	delete() {
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const body = JSON.stringify(this.state);
		fetch(`/api/risk_measures/${this.state.id}/`, { headers, method: 'DELETE', body }).then(() => this.setState({
			catalog: this.props.report.id,
			checkpoint: this.props.checkpoint.id,
			id: '',
			contact: '',
			till: '',
			importance: '',
			free_text: ''
		}));
	}

	@autobind
	uploadFile(event) {
		const formData = new FormData();
		formData.append('picture', event.target.files[0]);
		const headers = {
			'Authorization': `Token ${this.props.auth.token}`
		};
		fetch(`/api/risk_measures/${this.state.id}/`, {
			headers,
			method: 'PATCH',
			body: formData
		}).then(
			res => res.json()).then(res => this.setState(res));
	}

	@autobind
	deleteFile() {
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const target = 'picture';
		const body = JSON.stringify({[target]: null});
		fetch(`/api/risk_measures/${this.state.id}/`, {headers, method: 'PATCH', body}).then(
			res => res.json()).then(cc => this.setState(cc))
	}
	@autobind
	changeRelevance(e) {
		const relevance = e.target.value;
		this.setState({
			relevance: relevance
		}, this.submit);
	}
	@autobind
	changeInput(e) {
		const { value, name } = e.target;
		if(value === '---') {
			this.setState({ [name]: null });
		} else {
			this.setState({ [name]: value });
		}
	}
	render() {
		const contactList = this.props.report.contacts;
		return (<ListGroupItem>
			<FormGroup row>
					<Col sm={10}>
						<h5>
							{this.props.measure.name}
						</h5>
					</Col>
					<Col sm={2}>
						<Label>
							Relevanz
						</Label>
						<Input type="select" value={this.state.relevance} onChange={this.changeRelevance}>
							<option value={0}>---</option>
							<option value={1}>Ja</option>
							<option value={2}>Nein</option>
							<option value={3}>Nicht zutreffend</option>
						</Input>
					</Col>
			</FormGroup>
			{this.state.relevance > 0 &&
				<FormGroup row>
					<Col sm={3}>
						<Label>
							Priorität
						</Label>
						<Input type="select" value={this.state.importance} onChange={this.changeInput}>
							<option></option>
							<option>0</option>
							<option>1</option>
							<option>2</option>
							<option>3</option>
							<option>4</option>
							<option>5</option>
							<option>6</option>
							<option>7</option>
						</Input>
					</Col>
                    <Col sm={3}>
						<Label>
							Termin
						</Label>
						<Input type='date' name='till' value={this.state.till} onBlur={this.submit} onChange={this.changeInput} />
					</Col>
                    <Col sm={3}>
						<Label>
							Verantwortlicher
						</Label>
						<Input type='select' name='contact' value={this.state.contact} onBlur={this.submit} onChange={this.changeInput}>
							<option value={null}>---</option>
							{contactList.map((contact, index) => <option key={`option_${index}`} value={contact.id}>{contact.name}</option>)}
						</Input>
					</Col>
                    <Col sm={3}>
						<Label>
							Kontrolle
						</Label>
						<Input type='select' name='control' value={this.state.control} onBlur={this.submit} onChange={this.changeInput}>
							<option value={null}>---</option>
							{contactList.map((contact, index) => <option key={`option_${index}`} value={contact.id}>{contact.name}</option>)}
						</Input>
					</Col>
                    <Col sm={12}>
						<Label>
							Freitext
						</Label>
						<Input type='textarea' name='free_text' value={this.state.free_text} onBlur={this.submit} onChange={this.changeInput} />
					</Col>
					<Col sm={8}>
                        <Label>
							Anhang
						</Label>
						<Input type='file' onChange={this.uploadFile} />
						{picOrNot(this.state.picture, this.state.picture)}
					</Col>
                    <Col sm={4}>
						<Button style={{'float': 'right'}} color='danger' size={'sm'} onClick={this.deleteFile}
								data-target='1'>
							<i className='fa fa-trash'> </i> Anhang löschen
						</Button>
					</Col>
				</FormGroup>}
		</ListGroupItem>);
	}
}
